import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../seo/seo.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-cucine-industriali',
  imports: [CommonModule],
  templateUrl: './pastificio.html',
  styleUrls: ['./pastificio.scss'],
})
export class CucineIndustrialiComponent implements OnInit {
  constructor(private router: Router, private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Pulizia cucine industriali a Pescara | SAMI Pulizie',
      description:
        'Pulizia e sanificazione professionale per cucine industriali a Pescara e provincia. Sgrassatura cappe e filtri, superfici, pavimenti e aree di preparazione. Sopralluogo gratuito.',
      keywords:
        'pulizia cucine industriali Pescara, sanificazione cucina professionale, sgrassatura cappe filtri, pulizia ristoranti, pulizia mense, igiene alimentare, SAMI Pulizie',
      canonicalUrl: '/cucine-industriali',

      ogTitle: 'Pulizia cucine industriali a Pescara | SAMI Pulizie',
      ogDescription:
        'Servizi per cucine professionali: sgrassatura, pulizia cappe e filtri, superfici e pavimenti. Sopralluogo gratuito.',
      ogImage: '/assets/logo.png',
      ogType: 'website',

      twitterCard: 'summary_large_image',
      twitterTitle: 'Pulizia cucine industriali a Pescara | SAMI Pulizie',
      twitterDescription:
        'Interventi professionali per cucine industriali: cappe, filtri, superfici e aree di preparazione. Sopralluogo gratuito.',
      twitterImage: '/assets/logo.png',

      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Pulizia cucine industriali',
        description:
          'Pulizia e sanificazione per cucine professionali: sgrassatura cappe e filtri, superfici di lavoro, pavimenti e aree di preparazione.',
        provider: {
          '@type': 'CleaningService',
          name: 'SAMI Pulizie',
          url: 'https://samipulizie.it/',
          logo: 'https://samipulizie.it/assets/logo.png',
        },
        areaServed: { '@type': 'AdministrativeArea', name: 'Pescara' },
        url: 'https://samipulizie.it/cucine-industriali',
      },
    });
  }

  navigateToPreventiviSito() {
    this.router.navigateByUrl('/preventivo');
  }
}
